
export default {
  download: 'Baixar',
}
